<template>
    <div class="home">
        <div class="main-content">
            <div class="article">
                <Widget position="main_content"/>
            </div>
        </div>
        <div class="about_report">
            <div class="main-content">
                <div class="article">
                    <Widget position="about_report"/>
                </div>
            </div>
        </div>
        <div class="map">
            <div class="main-content">
                <div class="article">
                    <Widget position="map"/>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Widget from "@/components/app/Widget";

    export default {
        name: 'home',
        components: {
            Widget
        },
        created () {
            this.scrollToTop()
        },
        methods: {
            // Прокручивание к началу страницы
            scrollToTop () {
                window.scrollTo(0, 0)
            }
        }
    }
</script>
